// @ts-nocheck
import classNames from "classnames";
import { Fragment, useMemo, useRef, useState } from "react";
import { Popover, Whisper } from "rsuite";
import useGlobals from "../../api/api-hooks/globals/useGlobal";
import AppSpinner from "../../elements/AppSpinner";
import CircleIcon from "../../elements/CircleIcon";
import CreateRecordDrawer from "../Drawers/Records/CreateRecordDrawer";
import DropdownMenuDivider from "../Menus/DropdownMenuDivider";
import DropdownOptionWithIcon from "../Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "../Menus/PopoverDropdownMenu";
import QuickNoteLink from "./QuickNote/QuickNoteLink";
import QuickNoteModal from "./QuickNote/QuickNoteModal";
import FormBuilderDrawer from "../FormBuilder/FormBuilderDrawer";
import FormBuilderSuccessModal from "../FormBuilder/FormBuilderSuccessModal";

const empty: [] = [];
const emptyPrefill: [] = [];

const OptionList = ({ sidebarOpen, item }) => {
  const { globals: quickCreates, globalsLoading: quickCreatesLoading } =
    useGlobals("QuickCreates");
  const [quickNoteOpen, setQuickNoteOpen] = useState(false);
  const [quickActivitiesOpen, setQuickActivitesOpen] = useState(false);
  const [createRecordsDrawer, setCreateRecordsDrawer] = useState(false);
  const [createFormDrawer, setCreateFormDrawer] = useState(false);
  const [quickCreate, setQuickCreate] = useState(undefined);
  const [successFormID, setSuccessFormID] = useState("");

  const whisperRef = useRef(null);

  const handleSelectQuickCreate = (quickCreate) => {
    setCreateRecordsDrawer(true);
    setQuickCreate(quickCreate);
  };

  const onCreateRecordDrawerCreate = () => {
    setCreateRecordsDrawer(false);
    setQuickCreate(undefined);
  };

  const finalQuickCreates = useMemo(() => {
    return Array.isArray(quickCreates)
      ? quickCreates.filter((q) => q?.ShowInSidebar)
      : empty;
  }, [quickCreates]);

  const onCreateForm = () => {
    setCreateRecordsDrawer(false);
    setCreateFormDrawer(true);
  };

  const handleCloseFormBuilder = () => {
    setCreateFormDrawer(false);
  };

  const baseSidebarLinkCss =
    "tw:text-[13px] tw:transition tw:delay-50 tw:duration-300 tw:ease-in-out tw:hover:border tw:hover:border-superlight tw:hover:bg-sidebar-link tw:font-medium tw:text-dark tw:cursor-pointer tw:rounded-md tw:block tw:no-underline";

  return (
    <>
      <Whisper
        preventOverflow
        placement={"autoHorizontal"}
        trigger="click"
        ref={whisperRef}
        onOpen={() => setQuickActivitesOpen(true)}
        onClose={() => setQuickActivitesOpen(false)}
        speaker={
          <Popover
            className="sidebar-popover"
            full
            onClick={() => {
              whisperRef.current?.close();
            }}
          >
            <PopoverDropdownMenu>
              {quickCreatesLoading ? (
                <AppSpinner />
              ) : (
                <>
                  <div className="d-flex align-items-center">
                    <i
                      className="mdi mdi-lightning-bolt text-warning mx-2"
                      style={{ fontSize: 18 }}
                    />
                    <h5 className="mb-0 text-dark">Quick Activites</h5>
                  </div>
                  <DropdownMenuDivider />

                  {finalQuickCreates.length > 0 ? (
                    <>
                      {finalQuickCreates.map((quickCreate) => {
                        if (!quickCreate?.ShowInSidebar) return null;

                        return (
                          <Fragment key={quickCreate.id}>
                            <DropdownOptionWithIcon
                              name={quickCreate.Name}
                              onClick={() =>
                                handleSelectQuickCreate(quickCreate)
                              }
                              icon={quickCreate.Icon}
                            />
                          </Fragment>
                        );
                      })}
                    </>
                  ) : (
                    <small className="ml-3">
                      You don&apos;t have any quick actions.
                    </small>
                  )}
                </>
              )}
              <DropdownMenuDivider />
              <QuickNoteLink
                sidebarOpen={sidebarOpen}
                setQuickNoteOpen={setQuickNoteOpen}
              />
            </PopoverDropdownMenu>
          </Popover>
        }
      >
        <div
          className={classNames(
            `${baseSidebarLinkCss} tw:flex tw:items-center tw:mx-3 tw:mb-2 tw:h-[34px]`,
            {
              "tw:px-2": sidebarOpen,
              "tw:justify-center tw:px-0": !sidebarOpen,
              "tw:border tw:border-superlight tw:bg-sidebar-link":
                quickActivitiesOpen,
              "tw:border tw:border-transparent": !quickActivitiesOpen,
            }
          )}
        >
          <i
            className="mdi mdi-lightning-bolt tw:text-primary"
            style={{ fontSize: 20 }}
          />
          {sidebarOpen && <div className="tw:pl-2 tw:mb-0">Quick Add</div>}
        </div>
      </Whisper>
      <CreateRecordDrawer
        open={createRecordsDrawer}
        onClose={() => setCreateRecordsDrawer(false)}
        onCreate={onCreateRecordDrawerCreate}
        onCreateForm={onCreateForm}
        moduleAPIName={quickCreate?.ModuleAPIName}
        prefill={quickCreate?.PrefillPairs ?? emptyPrefill}
        defaultRecordLayout={quickCreate?.Layout}
      />
      {createFormDrawer && (
        <FormBuilderDrawer
          open={createFormDrawer}
          onClose={() => handleCloseFormBuilder()}
          moduleAPIName={quickCreate?.ModuleAPIName}
          prefill={quickCreate}
          existingForm={null}
          setSuccessFormID={setSuccessFormID}
        />
      )}
      <FormBuilderSuccessModal
        open={!!successFormID}
        onClose={() => setSuccessFormID("")}
        formID={successFormID}
      />
      <QuickNoteModal open={quickNoteOpen} setOpen={setQuickNoteOpen} />
    </>
  );
};

export default OptionList;
